import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from "@angular/core";
import { RequestBwt } from "../../../../../models/request/request-bwt";
import { KeyValueObject } from "../../../../../models/core/KeyValueObject";
import { forkJoin, Subscription } from "rxjs";
import { ContragentsService } from "../../../../../../categories/contragents/contragents.service";
import { ContragentWithContactDto } from "../../../../../models/contragent/contragent-with-contact-dto";
import { DaDataAddressComponent } from "../../../../dadata-address/dadata-address.component";
import { AddressSuggestion } from "../../../../../models/dadata-address/address-suggestion";
import { RequestsService } from "../../../../../services/requests.service";
import { NgForm } from "@angular/forms";
import { CustomerObjectsService } from "../../../../../../categories/customer-objects/customer-objects.service";
import { CustomerObjectContactDto, CustomerObjectWithContactsDto } from "../../../../../models/customerObject/customer-object-with-contacts.dto";
import { CreateCustomerObjectComponent } from "../../../../customer-object/create-customer-object/create-customer-object.component";
import { DialogService } from "@progress/kendo-angular-dialog";
import { NotificationService } from "../../../../../../core/services/notification.service";
import { DropDownFilterSettings } from "@progress/kendo-angular-dropdowns";
import { AddressClarificationComponent } from "../../../../adresses/address-clarification/address-clarification.component";

@Component({
	selector: 'request-page-customer-object-info',
	templateUrl: './request-page-customer-object-info.component.html',
	styleUrls: ['./request-page-customer-object-info.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class RequestPageCustomerObjectInfoComponent implements OnInit {

	@ViewChild('entityForm') public entityForm: NgForm;
	@ViewChild("dadataAddressControl") dadataAddressControl: DaDataAddressComponent;

	@Input() request: RequestBwt = null;
	@Input() dataSaving: boolean = false;

	@Output() refreshRequestEvent: EventEmitter<RequestBwt> = new EventEmitter<RequestBwt>();

	customerObjectDefaultItem: KeyValueObject = new KeyValueObject(0, 'Не выбрано');
	dropDownFilterSettings: DropDownFilterSettings = { caseSensitive: false, operator: 'contains' };

	customerObject: CustomerObjectWithContactsDto = new CustomerObjectWithContactsDto;
	savedCustomerObject: CustomerObjectWithContactsDto = new CustomerObjectWithContactsDto;
	savedCustomerObjectId: number;
	selectedCustomerObjectHasCoordinates: boolean = false;
	selectedCustomerObjectCoordinates: number[] = [];

	contragentSearchPauseTime = 500;
	contragentsSearchDelay: NodeJS.Timer;
	contragentsSearchSubsription: Subscription;

	customerObjects: KeyValueObject[] = [];
	contragents: KeyValueObject[] = [];
	isEditing: boolean = false;
	isOjbectSelectEditing: boolean = false;
	isSelectEditing: boolean = false;
	loading: boolean;
	cardOpened: boolean = false;
	isClientEditing: boolean = false;

	isCustomerObjectSaved: boolean = true;

	constructor(
		private customerObjectsService: CustomerObjectsService,
		private contragentsService: ContragentsService,
		private requestsService: RequestsService,
		private dialogService: DialogService,
		private notificationService: NotificationService
	) { }

	ngOnInit(): void {
		this.loading = true;
		const customerObjects$ = this.customerObjectsService.getCustomerObjectsByContragent(this.request.customerContragentId);

		if (this.customerObjectExist) {
			const customerObject$ = this.customerObjectsService.getCustomerObjectWithContacts(this.request.customerObjectId);
			const contragent$ = this.contragentsService.getContragentWithContact(this.request.customerContragentId);

			forkJoin([customerObjects$, customerObject$, contragent$]).subscribe((resp) => {
				this.customerObjects = resp[0];
				this.customerObject = { ...resp[1] };
				this.updateCustomerObjectAddress();
				this.setSelectedContragentName(resp[2]);
				this.setCustomerObjectCoordinates();
				this.loading = false;
			});
		}
		else {
			this.customerObject = new CustomerObjectWithContactsDto();
			customerObjects$.subscribe((resp) => {
				this.customerObjects = resp;
				this.loading = false;
			});
		}
	}

	setCustomerObjectCoordinates() {
		if (this.customerObject.latitude &&
			this.customerObject.longitude) {
			this.selectedCustomerObjectHasCoordinates = true;
			this.selectedCustomerObjectCoordinates = [
				this.customerObject.latitude,
				this.customerObject.longitude];
		}
		else {
			this.selectedCustomerObjectCoordinates = [55.751952, 37.600739];
			this.selectedCustomerObjectHasCoordinates = false;
		}
	}

	clientChange(value: string): void {
		this.isCustomerObjectSaved = false;
		this.customerObject.customerObjectId = 0;
		this.customerObject.name = "";
		this.customerObject.address = null;
		let contragent = this.contragents.find(x => x.name == value);
		this.customerObject.contragentId = contragent != null ? contragent.id : null;

		this.customerObjectsService.getCustomerObjectsByContragent(this.customerObject.contragentId).subscribe((resp) => {
			this.customerObjects = resp;
		});

		if (this.customerObject.contragentId && this.customerObject.contragentId != 0) {
			this.contragentsService.getContragentWithContact(this.customerObject.contragentId).subscribe(resp => {
				this.setSelectedContragentName(resp);
				this.setCustomerObjectCoordinates();
			});
		}
	}

	clientFilterChange(value: string): void {
		if (!value || value.trim() == '' || value.trim().length < 3) {
			this.contragents = this.customerObject.contragentName
				? this.contragents.filter(x => x.id == this.customerObject.contragentId)
				: [];
		}
		else {
			this.searchContragents(value);
		}
	}

	searchContragents(value: string) {
		if (this.contragentsSearchDelay) {
			clearTimeout(this.contragentsSearchDelay);
		}

		this.contragentsSearchDelay = setTimeout(() => {
			if (this.contragentsSearchSubsription) {
				this.contragentsSearchSubsription.unsubscribe();
			}

			this.contragentsSearchSubsription = this.contragentsService.searchByName(value)
				.subscribe((response) => {
					this.contragents = response.data;
				});
		}, this.contragentSearchPauseTime);
	}

	setSelectedContragentName(contragent: ContragentWithContactDto) {
		this.customerObject.contragentName = contragent.isIndividual
			? contragent.contactFullName
				? contragent.contactFullName
				: contragent.contactPhone
			: contragent.name
				? contragent.name
				: contragent.inn;
	}

	onAddressChange(value: AddressSuggestion) {
		this.customerObject.address = value.address;
	}

	save() {
		this.dataSaving = true;
		if (this.customerObject.addressDescription) {
			this.request.customerObjectAddress = `${this.customerObject.address}, ${this.customerObject.addressDescription}`;
		} else {
			this.request.customerObjectAddress = this.customerObject.address;
		}

		if (this.customerObject.contragentId != this.savedCustomerObject.contragentId) {
			this.notificationService.confirmation({
				title: 'Изменение клиента',
				message: `При изменении клиента объекта обслуживания будет изменен клиент заявки`,
				type: 'question',
				confirmButtonText: 'Сохранить',
				cancelButtonText: 'Отмена',
				showCloseButton: false,
			},
				() => this.updateCustomerObjectWithRequest(),
				() => this.dataSaving = false);
		}
		else {
			this.updateCustomerObject();
		}
	}

	showAddressClarification(isRequest: boolean) {
		const dialogRef = this.dialogService.open({
			content: AddressClarificationComponent,
			width: '80%',
			height: '820px',
			minWidth: '800px'
		});
		const addressClarification = <AddressClarificationComponent>dialogRef.content.instance;

		addressClarification.height = 460;
		addressClarification.address = this.customerObject.address;
		addressClarification.onCancelEvent.subscribe(() => {
			this.dataSaving = false;
			dialogRef.close();
		});
		addressClarification.onContinueEvent.subscribe(yandexModel => {

			this.customerObject.yandexModel = yandexModel;

			this.customerObjectsService.updateCustomerObjectWithContacts(this.customerObject).subscribe((resp) => {
				this.customerObject.yandexModel = null;
				if (isRequest) {
					this.updateRequest();
				} else {
					this.dataSaving = false;
					this.isEditing = false;
				}

				dialogRef.close();
			}, () => {
				this.dataSaving = false;
				this.isEditing = false;
				this.isClientEditing = false;
				this.isOjbectSelectEditing = false;
				this.customerObject.yandexModel = null;
			});
		});
	}

	updateCustomerObject() {
		this.customerObject.ignoreAddressCheck = true;
		this.customerObjectsService.updateCustomerObjectWithContacts(this.customerObject).subscribe(res => {
			if (res.isSuccessful) {
				if (res.data.addressOk) {
					this.dataSaving = false;
					this.isEditing = false;
					this.isClientEditing = false;
					this.isOjbectSelectEditing = false;
					this.setCustomerObjectCoordinates();
				} else {
					this.showAddressClarification(false);
				}
			}
		}, () => { this.dataSaving = false; this.isEditing = false; this.isOjbectSelectEditing = false; this.isClientEditing = false; });
	}

	updateCustomerObjectWithRequest() {
		this.customerObject.ignoreAddressCheck = true;
		this.customerObjectsService.updateCustomerObjectWithContacts(this.customerObject).subscribe(res => {
			if (res.isSuccessful) {
				if (res.data.addressOk) {
					this.updateRequest();
				} else {
					this.showAddressClarification(false);
				}
			}
		}, () => { this.dataSaving = false; this.isEditing = false; this.isOjbectSelectEditing = false; this.isClientEditing = false; });
	}

	openCustomerObjectDialog(isEditing: boolean) {
		const dialogRef = this.dialogService.open({ content: CreateCustomerObjectComponent, width: '60%', height: '620px' });
		const createContragentForm = <CreateCustomerObjectComponent>dialogRef.content.instance;

		createContragentForm.selectedCustomerObject = isEditing
			? this.customerObject
			: new CustomerObjectWithContactsDto;
		createContragentForm.contragentId = this.request.customerContragentId;
		createContragentForm.isEditing = isEditing;
		createContragentForm.commitChanges = true;
		createContragentForm.onCancelEvent.subscribe(() => dialogRef.close());
		createContragentForm.onContinueEvent.subscribe((customerObject) => {
			dialogRef.close();
			this.customerObject = customerObject;
			this.refreshCustomerObjects(customerObject.contragentId);
			this.setCustomerObjectCoordinates();

			const objectChangedOnRequest = customerObject.customerObjectId !== this.request.customerObjectId;
			if (objectChangedOnRequest) {
				this.dataSaving = true;
				this.updateRequest();
			} else {
				this.requestsService.getBwtById(this.request.requestId).subscribe(updatedRequest => {
					this.request = updatedRequest.entity;
					this.refreshRequestEvent.emit(this.request);
				});
			}
		});
	}

	refreshCustomerObjects(contragentId: number) {
		this.customerObjectsService.getCustomerObjectsByContragent(contragentId).subscribe((resp) => {
			this.customerObjects = resp;
		});
	}

	updateRequest() {
		this.requestsService.getById(this.request.requestId).subscribe(resp => {
			resp.entity.customerObjectId = this.customerObject.customerObjectId;
			resp.entity.customerObjectName = this.customerObject.name;
			if (this.customerObject.contragentId) {
				resp.entity.customerContragentId = this.customerObject.contragentId;
				resp.entity.customerContragentName = this.customerObject.contragentName;
			}
			resp.entity.responsibleUserId = this.request.responsibleUserId;
			resp.entity.reclamationDeviceId = this.request.reclamationDeviceId;

			this.requestsService.update(resp.entity, null).subscribe(() => {
				this.requestsService.getBwtById(this.request.requestId).subscribe(updatedRequest => {
					this.request = updatedRequest.entity;
					this.refreshRequestEvent.emit(this.request);
					this.updateCustomerObjectAddress();
					this.contragentsService.getContragentWithContact(this.request.customerContragentId).subscribe(contragent => {
						if (this.customerObject.customerObjectId && this.customerObject.customerObjectId != 0) {
							this.setSelectedContragentName(contragent);
						}
						this.dataSaving = false;
						this.isEditing = false;
						this.isClientEditing = false;
						this.isOjbectSelectEditing = false;
					});
				});
			});
		});
	}

	turnOnEdit() {
		this.isEditing = true;
		this.savedCustomerObject = { ...this.customerObject };
	}

	turnOffEdit() {
		this.isEditing = false;
		this.customerObject = { ...this.savedCustomerObject };
		this.entityForm.resetForm(this.customerObject);
		this.updateCustomerObjectAddress();
	}

	turnOnSelectEdit() {
		this.isOjbectSelectEditing = true;
		this.savedCustomerObjectId = this.customerObject.customerObjectId;
	}

	turnOffSelectEdit() {
		this.isOjbectSelectEditing = false;
		this.customerObject.customerObjectId = this.savedCustomerObjectId;
	}

	saveSelectedCustomerObject() {
		this.isSelectEditing = false;
		this.isEditing = true;
		this.isOjbectSelectEditing = false;
		this.dataSaving = true;
		if (this.customerObject.customerObjectId && this.customerObject.customerObjectId != 0) {
			this.customerObjectsService.getCustomerObjectWithContacts(this.customerObject.customerObjectId).subscribe(resp => {
				this.customerObject = resp;
				this.updateCustomerObjectAddress();
				this.updateRequest();
				this.setCustomerObjectCoordinates();
				this.isCustomerObjectSaved = true;
			});
		}
		else {
			this.customerObject = new CustomerObjectWithContactsDto();
			this.updateCustomerObjectAddress();
			this.updateRequest();
			this.isCustomerObjectSaved = true;
		}
	}

	updateCustomerObjectAddress() {
		if (this.dadataAddressControl) {
			this.dadataAddressControl.initValue(this.customerObject.address);
			this.setCustomerObjectCoordinates();
		}
	}

	toggleCard() {
		this.cardOpened = !this.cardOpened;
	}

	turnOnClientEditing(isClientEditing: boolean) {
		this.isClientEditing = isClientEditing;

		if (!isClientEditing) {
			this.customerObjectsService.getCustomerObjectsByContragent(this.request.customerContragentId).subscribe((resp) => {
				this.customerObjects = resp;

				if (this.isClientEditing) {
					this.savedCustomerObject = { ...this.customerObject };
				}
				else {
					this.customerObject = { ...this.savedCustomerObject };
				}
			});
		} else {
			if (this.isClientEditing) {
				this.savedCustomerObject = { ...this.customerObject };
			}
			else {
				this.customerObject = { ...this.savedCustomerObject };
			}
		}
	}

	get customerObjectExist() {
		return this.request.customerObjectId && this.request.customerObjectId != 0;
	}

	get canSave() {
		return (!this.entityForm.pristine || this.addressHasChanged) && this.entityForm.valid;
	}

	get addressHasChanged() {
		return this.savedCustomerObject && this.savedCustomerObject.address != this.customerObject.address;
	}

	get canSaveSelectedCustomerObject() {
		return this.isSelectEditing && this.customerObject.customerObjectId != this.savedCustomerObjectId;
	}
}
